import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiHandler } from '../../api/apihandler';
import { MENU_CHART_LIST } from '../../api/constants';

// Async thunk for fetching menu chart
export const fetchMenuChart = createAsyncThunk(
  'menuChart/fetchMenuChart',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiHandler(MENU_CHART_LIST, "POST", {});
      
      if (response.data?.response?.status === 200) {
        return response.data.data;
      } else {
        return rejectWithValue(response.data?.response?.message || 'Failed to fetch menu chart');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

const menuChartSlice = createSlice({
  name: 'menuChart',
  initialState: {
    // Menu data
    weekName: '',
    days: [],
    
    // Loading state
    loading: false,
    
    // Error state
    error: null
  },
  reducers: {
    clearErrors: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch menu chart
      .addCase(fetchMenuChart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuChart.fulfilled, (state, action) => {
        state.loading = false;
        state.weekName = action.payload?.week_name || '';
        state.days = Array.isArray(action.payload?.days) ? action.payload.days : [];
      })
      .addCase(fetchMenuChart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearErrors } = menuChartSlice.actions;

// Selectors
export const selectDays = (state) => state.menuChart.days;
export const selectWeekName = (state) => state.menuChart.weekName;
export const selectLoading = (state) => state.menuChart.loading;
export const selectError = (state) => state.menuChart.error;

export default menuChartSlice.reducer;
